import { useEffect } from 'react';
import { BRAND } from '@shared/constants/brand';

const SITE_URL = 'https://momeokji.kr';

function setMeta(selector: string, attrs: Record<string, string>, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, v);
    document.head.appendChild(el);
  }
  el.content = content;
}

/** 페이지 제목, description, canonical, robots 메타를 설정합니다. 방 페이지는 noindex. */
export function useDocumentMeta(options: { title?: string; description?: string; noIndex?: boolean; path?: string }): void {
  const { title, description, noIndex = false, path } = options;
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND.name}` : BRAND.pageTitle;
    const desc = description ?? BRAND.description;
    document.title = fullTitle;
    setMeta('meta[name="description"]', { name: 'description' }, desc);
    setMeta('meta[property="og:title"]', { property: 'og:title' }, fullTitle);
    setMeta('meta[property="og:description"]', { property: 'og:description' }, desc);
    setMeta('meta[name="robots"]', { name: 'robots' }, noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
    const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical && !noIndex) canonical.href = `${SITE_URL}${path ?? location.pathname}`;
    if (canonical) canonical.toggleAttribute('data-noindex', noIndex);
    return () => {
      document.title = BRAND.pageTitle;
      setMeta('meta[name="description"]', { name: 'description' }, BRAND.description);
      setMeta('meta[property="og:title"]', { property: 'og:title' }, BRAND.pageTitle);
      setMeta('meta[property="og:description"]', { property: 'og:description' }, BRAND.description);
      setMeta('meta[name="robots"]', { name: 'robots' }, 'index, follow, max-image-preview:large');
    };
  }, [title, description, noIndex, path]);
}
